/**
 * 郵便番号→住所 変換スクリプト（Google transliterate API 使用）
 *
 * Author : T.Tomida <tomipetit@gmail.com>
 * Create : 2017.08
 */
import StrReplace from './strReplace';

export default class {
	constructor(params) {
		this.config = Object.assign({}, this.defaults(), params);
	}

	defaults() {
		return {}
	}
	// Google transliterate APIにリクエスト
	request(zipCode) {
		return new Promise((resolve, reject) => {
			// 郵便番号を整形
			let chkCode = StrReplace.toOneByteCharacter(zipCode).replace(/-/g, '');
			if (chkCode.length === 7) {
				chkCode = chkCode.substring(0, 3) + '-' + chkCode.substring(3, 7);
			} else {
				reject();
			}

			$.ajax({
				type: 'GET',
				dataType: 'jsonp',
				url: 'https://www.google.com/transliterate',
				data: {
					langpair: 'ja-Hira|ja',
					text: chkCode,
					jsonp: 'callback'
				},
				dataType: 'jsonp',
				jsonpCallback: 'callback'
			})
				.done(resp => {
					resolve(resp);
				})
				.fail(() => {
					reject();
				})
		});
	}
	// 受け取ったデータの加工処理
	process(resp) {
		const prefList = this.prefList();
		const respText = resp[0][1][0];
		let respObj = {};
		return new Promise((resolve, reject) => {
			for (let i = 0; i < 47; i++) { // 住所が返ってきているかどうかチェック
				let re = new RegExp('^' + prefList[i]);
				if (respText.match(re)) {
					respObj = {
						result: true,
						prefNo: i + 1,
						pref: prefList[i],
						below: respText.replace(prefList[i], ''),
						adr: respText
					}
					break;
				}
			}
			if (!respObj) {
				reject();
			}
			resolve(respObj);
		});
	}
	check(zipCode) {
		return new Promise((resolve, reject) => {
			this.request(zipCode)
				.then(resp => {
					return this.process(resp);
				})
				.then(resp => {
					console.log(resp)
					resolve(resp);
				})
				.catch(() => {
					reject();
				})
		});
	}
	prefList() {
		return [
			'北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県',
			'埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
			'岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
			'鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県',
			'佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
		]
	}
}
